import React from 'react';

// Port of .form-group / .form-control from base_component.css.
export function FormControl({ label, id, ...inputProps }) {
  return (
    <div className="form-group">
      {label && <label htmlFor={id}>{label}</label>}
      <input id={id} className="form-control" {...inputProps} />
    </div>
  );
}

export default FormControl;
